import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']);

import styled from 'styled-components';

export default styled.div(_templateObject, function (_ref) {
  var shouldFitContainer = _ref.shouldFitContainer;
  return shouldFitContainer ? '' : 'max-width: 300px;';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dropdown-menu/dist/esm/styled/WidthConstrainer.js
// module id = 681
// module chunks = 0